var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-main"},_vm._l((_vm.navs),function(item,index){return _c('span',{key:index,staticClass:"nav-span"},[_c('a',{staticClass:"nav-link",class:{ 'nav-active': index === _vm.activeIndex },on:{"click":function($event){return _vm.toggleNav(item,index)}}},[_c('i',{class:item.icon}),_vm._v(" "+_vm._s(item.name)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }